import { render, staticRenderFns } from "./ViewRequestedAttestation.vue?vue&type=template&id=5047edb2&scoped=true&"
import script from "./ViewRequestedAttestation.vue?vue&type=script&lang=js&"
export * from "./ViewRequestedAttestation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5047edb2",
  null
  
)

export default component.exports